import { render, staticRenderFns } from "./newBranch.vue?vue&type=template&id=3480c1af&"
import script from "./newBranch.vue?vue&type=script&lang=js&"
export * from "./newBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports